import { FC } from "react";
import { Box, Text } from "@chakra-ui/react";
import { errorColor, successColor } from "../../../utils/colors";

interface IndicatorStateProps {
  stateValue: {
    id: number;
    name: string;
  };
  additionalStyle?: object;
}

const IndicatorState: FC<IndicatorStateProps> = ({
  stateValue,
  additionalStyle = {},
}) => {
  const getStateColor = () => {
    switch (stateValue?.id) {
      case 1:
        return successColor;
      case 2:
        return errorColor;
      default:
        return "gray.500";
    }
  };

  return (
    <Box fontWeight="bold" style={additionalStyle}>
      <Text textTransform="capitalize" fontSize="sm" color={getStateColor()}>
        {stateValue?.name ?? "-"}
      </Text>
    </Box>
  );
};

export default IndicatorState;
